import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { FaPhone, FaEnvelope, FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa';

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_y06osce', 'template_porp6nu', formRef.current, 'fwg-iJ4all_4fpjnD')
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
          resetForm();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const resetForm = () => {
    // Reset form fields
    formRef.current.reset();
  };

  return (
    <div style={styles.container} id='contact'>
      <div style={styles.wrapper}>
        <div style={styles.left}>
          <h1 style={styles.title}>Contact Me</h1>
          <div style={styles.iconContainer}>
  <a
    href="tel:+917007695443"
    style={{ ...styles.iconButton, color: '#25d366' }}
    title="+91 7007695443"
  >
    <FaPhone size={30} />
  </a>
  <a
    href="mailto:abhishekpratapsinghb20245@gmail.com"
    style={{ ...styles.iconButton, color: '#ea4335' }}
    title="abhishekpratapsinghb20245@gmail.com"
  >
    <FaEnvelope size={30} />
  </a>
  <a
    href="https://www.linkedin.com/in/abhishek-pratap-singh-88523a207/"
    style={{ ...styles.iconButton, color: '#0077b5' }}
    title="LinkedIn: Abhishek Pratap Singh"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaLinkedin size={30} />
  </a>
  <a
    href="https://github.com/abhishekpratapsinghbeter"
    style={{ ...styles.iconButton, color: '#333' }}
    title="GitHub: abhishekpratapsinghbeter"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaGithub size={30} />
  </a>
  <a
    href="https://www.instagram.com/pratap.abhisheksingh181/"
    style={{ ...styles.iconButton, color: '#e4405f' }}
    title="@pratap.abhisheksingh181"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaInstagram size={30} />
  </a>
</div>

        </div>
        <div style={styles.right}>
          <form ref={formRef} onSubmit={handleSubmit} style={styles.form}>
            <input type="text" placeholder="Name" name="user_name" style={styles.input} />
            <input type="text" placeholder="Subject" name="user_subject" style={styles.input} />
            <input type="text" placeholder="Email" name="user_email" style={styles.input} />
            <textarea rows="5" placeholder="Message" name="message" style={styles.textarea} />
            <button style={styles.button}>Submit</button>
            {done && <span style={styles.thankYou}>Thank You</span>}
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    maxWidth: '1200px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 15px rgba(0,0,0,0.2)',
    borderRadius: '10px',
    overflow: 'hidden',
    position: 'relative',
  },
  left: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: '#fafafa',
  },
  title: {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center',
    color: '#333',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '15px',
  },
  iconButton: {
    textDecoration: 'none',
    transition: 'color 0.3s, transform 0.3s',
    padding: '10px',
  },
  right: {
    flex: 1,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#f9f9f9',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  input: {
    width: '100%',
    padding: '15px',
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '16px',
  },
  textarea: {
    width: '100%',
    padding: '15px',
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '16px',
    resize: 'none',
  },
  button: {
    padding: '15px',
    margin: '20px 0',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#59b256',
    color: 'white',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s, transform 0.3s',
  },
  thankYou: {
    color: '#59b256',
    fontSize: '18px',
    marginTop: '10px',
    textAlign: 'center',
  },
  '@media screen and (max-width: 768px)': {
    wrapper: {
      flexDirection: 'column',
      width: '100%',
    },
    left: {
      alignItems: 'center',
      padding: '20px 10px',
    },
    right: {
      width: '100%',
      marginTop: '20px',
      padding: '20px 10px',
    },
    input: {
      width: '100%',
      padding: '12px',
      margin: '8px 0',
    },
    textarea: {
      width: '100%',
      padding: '12px',
      margin: '8px 0',
    },
  },
  '@media screen and (max-width: 480px)': {
    title: {
      fontSize: '28px',
    },
    iconButton: {
      padding: '8px',
    },
    button: {
      padding: '12px',
      fontSize: '14px',
    },
    thankYou: {
      fontSize: '16px',
    },
  },
};

export default Contact;
